import {
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { UniQuestion } from "../../dao/UniQuestion";
import UcHumanBodyImage from "./UcHumanBodyImage";
import { SpwkUtilV3 } from "../../dao/SpwkUtilV3";
import { useTranslation } from "react-i18next";

type Props = {
  question: UniQuestion;
};

const UcCustom = ({ question }: Props) => {
  const { t } = useTranslation();
  return (
    <Grid container sx={{ pt: 4, pb: 0 }} direction={"column"}>
      {render_items(question)}
    </Grid>
  );

  function render_items(question: UniQuestion) {
    if (question.question_title === SpwkUtilV3.UcHumanBodyImage) {
      return <UcHumanBodyImage question={question} />;
    }
    if (question.question_title === SpwkUtilV3.BSRS5_ScoreIllustrate) {
      return (
        <Stack sx={{ gap: "12px" }}>
          <Typography>
            {t("BSRS-5 第1~5題加總後為總分。依據得分可分為幾個等級。")}
          </Typography>
          <TableContainer sx={{ display: { xs: "none", sm: "block" } }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFEFEF" }}>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("分數")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("狀態")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("建議")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("0-5分")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("一般正常範圍")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("表示身心適應狀況良好。")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("6-9分")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("輕度情緒困擾")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("宜做壓力管理，建議找家人或朋友談談，抒發情緒。")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ color: "#dc3545", border: "1px solid black" }}
                  >
                    {t("10-14分")}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#dc3545", border: "1px solid black" }}
                  >
                    {t("中度情緒困擾")}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#dc3545", border: "1px solid black" }}
                  >
                    {t("宜做專業諮詢，建議尋求心理諮詢或接受專業諮詢。")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ color: "#dc3545", border: "1px solid black" }}
                  >
                    {t("15分以上")}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#dc3545", border: "1px solid black" }}
                  >
                    {t("重度情緒困擾")}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#dc3545", border: "1px solid black" }}
                  >
                    {t("需高關懷，建議尋求專業輔導或精神醫療專業諮詢。")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* 0-5分 一般正常範圍 */}
          <TableContainer sx={{ display: { sm: "none" } }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                    }}
                  >
                    {t("分數")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("0-5分")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                    }}
                  >
                    {t("狀態")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("一般正常範圍")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("建議")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("表示身心適應狀況良好。")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* 6-9分 輕度情緒困擾 */}
          <TableContainer sx={{ display: { sm: "none" } }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("分數")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("6-9分")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("狀態")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("輕度情緒困擾")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("建議")}
                  </TableCell>
                  <TableCell sx={{ border: "1px solid black" }}>
                    {t("宜做壓力管理，建議找家人或朋友談談，抒發情緒。")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* 10-14分 中度情緒困擾 */}
          <TableContainer sx={{ display: { sm: "none" } }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("分數")}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid black", color: "#dc3545" }}
                  >
                    {t("10-14分")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("狀態")}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid black", color: "#dc3545" }}
                  >
                    {t("中度情緒困擾")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("建議")}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid black", color: "#dc3545" }}
                  >
                    {t("宜做專業諮詢，建議尋求心理諮詢或接受專業諮詢。")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* 15分以上 重度情緒困擾 */}
          <TableContainer sx={{ display: { sm: "none" } }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("分數")}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid black", color: "#dc3545" }}
                  >
                    {t("15分以上")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("狀態")}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid black", color: "#dc3545" }}
                  >
                    {t("重度情緒困擾")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    variant="head"
                    sx={{
                      backgroundColor: "#EFEFEF",
                      border: "1px solid black",
                      width: "30%",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {t("建議")}
                  </TableCell>
                  <TableCell
                    sx={{ border: "1px solid black", color: "#dc3545" }}
                  >
                    {t("需高關懷，建議尋求專業輔導或精神醫療專業諮詢。")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Typography>
            {t(
              "✱ 有自殺的想法：本題評分為 2 分以上（中等程度）時，即建議尋求專業輔導或精神科治療。"
            )}
          </Typography>
          <Typography sx={{ color: "#dc3545" }}>
            {t(
              "BSRS-5 總分若為 10 分以上，建議應進行心理諮詢，及主動追蹤關懷與協助。"
            )}
          </Typography>
        </Stack>
      );
    } else {
      alert("自訂的Question, 不是預期的" + question.question_title);
    }
  }
};

export default UcCustom;
